import moment from 'moment';
import { WeekDay } from '../api/contracts/menu';
import { WeekIndex } from '../types/menu';

export function getCurrentWeekNumber(): number {
  return moment().week();
}

export function getNextWeekNumber(): number {
  return moment().add(1, 'week').week();
}

export function getDayOfTheWeek(): number {
  return moment().weekday();
}

export function getWeekFirstDay(): WeekDay {
  return 'mon';
}

export function getWeekLastDay(): WeekDay {
  return 'sun';
}

export function getWeekNumberByWeekIndex(weekIndex: WeekIndex): number | null {
  return weekIndex === WeekIndex.THIS_WEEK
    ? getCurrentWeekNumber()
    : weekIndex === WeekIndex.NEXT_WEEK
    ? getNextWeekNumber()
    : null;
}
